const myACcountInit = () => {
  const forms = document.querySelectorAll('#customer_login');

  forms.forEach((form) => {
    let toggled = false;
    const registerForm = form.querySelector('form.register');
    const loginForm = form.querySelector('form.login');
    const registerToggle = form.parentElement.querySelector('.register-toggle');
    const loginToggle = form.parentElement.querySelector('.login-toggle');
    const toggles = form.parentElement.querySelectorAll('.toggleLoginRegister');

    const toggleRegister = () => {
      if (toggled) {
        registerForm.classList.add('hide');
        loginForm.classList.remove('hide');
        registerToggle.classList.remove('hide');
        loginToggle.classList.add('hide');
        toggled = false;
      } else {
        registerForm.classList.remove('hide');
        loginForm.classList.add('hide');
        registerToggle.classList.add('hide');
        loginToggle.classList.remove('hide');
        toggled = true;
      }
    };

    const classesInit = () => {
      if (registerForm) {
        registerForm.classList.add('hide');
      }
      if (loginToggle) {
        loginToggle.classList.add('hide');
      }
    };

    classesInit();

    toggles.forEach((toggler) => {
      toggler.addEventListener('click', () => toggleRegister());
    });
  });
};

export default myACcountInit;
